<template>
  <div class="get-payments-dialog" v-loading="loading">
    <div class="dialog-add-account__title">
      {{ dialogTitle ? dialogTitle : '' }}
    </div>

    <div class="get-payments-dialog__desc" v-html="'Get payments report'" />
    <div class="get-payments-dialog__data-picker">
      <span class="get-payments-dialog__data-title">Date range:</span>
      <div>
        <date-range-picker
          :key="lang"
          class="statistics__period-calendar"
          :class="{ 'statistics__period-calendar--open': isShow }"
          ref="picker"
          v-model="date"
          single-date-picker="range"
          :auto-apply="true"
          :always-show-calendars="true"
          :ranges="false"
          :locale-data="localeEN"
          @toggle="isShow = !isShow"
          opens="left"
        >
          <template #input="picker">
            {{ fixDate(picker.startDate, picker.endDate) }}
          </template>
        </date-range-picker>
      </div>
    </div>
    <div></div>
    <div class="get-payments-dialog__button-wrapper">
      <span class="error" v-if="dataError">{{ respErr }}</span>
      <ButtonElement text="Export" :disabled="!date.endDate && !date.startDate" @click-button="onExportPayments" />
    </div>
  </div>
</template>

<script>
import formValidate from '../../mixin/formValidate';
import { getCurrentDate, waitRequest } from '@/mixin';
import DateRangePicker from 'vue2-daterange-picker';
import ButtonElement from '../../components/elements/ButtonElement';
import axios from 'axios';
import { exportPayments } from '../../api/mutations';
import { DATE_PICKER_LOCALE_EN, DATE_PICKER_LOCALE_RU, MONTHES_EN } from '@/constants';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  name: 'GetPaymentsXLS',
  components: {
    DateRangePicker,
    ButtonElement,
  },
  mixins: [formValidate, getCurrentDate, waitRequest],
  data() {
    return {
      locale: process.env.VUE_APP_LOCALE,
      lang: this.$i18n._vm.locale,
      loading: false,
      isShow: false,
      fileUrl: '',
      respErr: '',
      dataError: false,
      currentDate: '',
      hours: new Date().getHours(),
      minutes: new Date().getMinutes(),
      seconds: new Date().getSeconds(),
      isDisabled: false,
      date: {
        startDate: new Date(),
        endDate: new Date(),
      },
      minDate: null,
      localeEN: DATE_PICKER_LOCALE_EN,
      monthsEn: MONTHES_EN,
      activePeriod: 'day',
    };
  },
  computed: {
    start_at() {
      return this.fixDateFormatNumbers(this.date.startDate);
    },
    end_at() {
      return this.fixDateFormatNumbers(this.date.endDate);
    },
    baActivePlatform() {
      return this.$store.state.Dialog.baActivePlatform;
    },
    dialogTitle() {
      return this.$store.state.Dialog.dialogTitle;
    },
  },

  created() {
    this.currentDate = this.fixDateFormatNumbers(new Date());
  },
  methods: {
    closeModal() {
      this.$store.dispatch('Dialog/closeDialog');
      this.$store.commit('Dialog/setData', { label: 'baActivePlatform', data: null });
      this.$store.commit('Dialog/setData', { label: 'dialogTitle', data: '' });
    },

    fixDate(start, end) {
      if (start && end) {
        let str = '';
        const startDay = start.getDate();
        const endDay = end.getDate();

        const startMonth = start.getMonth();
        const endMonth = end.getMonth();

        let nameStartMonth, nameEndMonth;
        nameStartMonth = this.monthsEn.find((el) => el.id === startMonth).shortName;
        nameEndMonth = this.monthsEn.find((el) => el.id === endMonth).shortName;
        if (startDay === endDay && startMonth === endMonth) {
          str = startDay + ' ' + nameStartMonth;
        } else if (startMonth === endMonth) {
          str = startDay + '-' + endDay + ' ' + nameStartMonth;
        } else {
          str = startDay + ' ' + nameStartMonth + ' - ' + endDay + ' ' + nameEndMonth;
        }

        return str;
      }
    },
    fixDateFormatNumbers(fixedDate) {
      if (fixedDate) {
        let date = new Date(fixedDate);
        let str = '';
        const startDay = String(date.getDate()).padStart(2, '0');
        const startMonth = String(date.getMonth() + 1).padStart(2, '0');
        const startYear = date.getFullYear();
        str = startYear + '-' + startMonth + '-' + startDay;
        return str;
      }
    },
    onExportPayments() {
      if (this.isLoading) return;
      const payment_date_from = this.getCurrentDate(this.date.startDate);
      const payment_date_to = this.getCurrentDate(this.date.endDate);
      waitRequest(
        exportPayments({
          payment_date_from,
          payment_date_to,
        }).then((response) => {
          const href = response?.data;
          const link = document.createElement('a');
          link.href = href;
          link.download = 'build.xlsx';
          document.body.appendChild(link);
          link.click();
          this.closeModal();
          this.$notify({
            message: this.$t('notify.document_loaded'),
            type: 'success',
          });
        })
      );
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

@keyframes settingsRotate {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.error {
  color: red;
}

.save-users-data {
  border: 1px solid #d8d9da;
  font-weight: 700;
  font-size: 1.6rem;
  line-height: 1.9rem;
  border-radius: 4px;
  height: 3.5rem;
  min-width: 12.5rem;
  text-align: center;
  padding-top: 7px;
  margin-right: 1rem;
}

.get-payments-dialog {
  &__data-picker {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  &__data-title {
    font-weight: 700;
  }

  &__button-wrapper {
    display: flex;
    margin-top: 3rem;
    align-items: center;

    .button {
      margin-left: auto;
    }
  }
}
</style>
